import { FlexBox } from '../../flex-box';
import { Text } from '../../text';
import { ExternalTooltipProps } from '../charts.model';
import { formatLongDate } from '../common/formatters';

export const DefaultTooltip = ({
    formatX,
    formatY,
    formatLabel = str => str,
    colorScale,
    dateKey,
    dataKey,
    datum,
}: ExternalTooltipProps) => {
    const color = colorScale?.(dataKey);
    return (
        <div className="text-content p-2 flex flex-col gap-1">
            <div className="font-bold" style={{ color }}>
                {formatLabel(dataKey)}
            </div>
            <FlexBox gap="sm">
                <Text as="span" size="xs" weight="medium" color="base">
                    {formatY(datum[dataKey])}
                </Text>
                <Text as="span" size="xs" weight="regular" color="deselect">
                    {formatX(datum[dateKey])}
                </Text>
            </FlexBox>
        </div>
    );
};

export const DefaultStackedTooltip = ({
    formatY,
    formatLabel = str => str,
    colorScale,
    dateKey,
    datum,
    datumByKey,
}: ExternalTooltipProps) => (
    <div className="p-2 flex flex-col gap-1">
        <Text color="base" weight="medium" size="xs">
            {formatLongDate(datum[dateKey])}
        </Text>
        {Object.values(datumByKey).map(d => {
            return (
                <FlexBox gap="sm" key={d.key} justifyContent="between">
                    <Text as="span" size="xs">
                        <span style={{ color: colorScale?.(d.key) }}>{formatLabel(d.key)}</span>
                    </Text>
                    <Text as="span" size="xs" weight="regular" color="deselect">
                        {formatY(d.datum[d.key])}
                    </Text>
                </FlexBox>
            );
        })}
    </div>
);
